/* eslint-disable camelcase */
export const ConversionEvent = {
  purchase: '1',
  signup: '2',
} as const;

export type NaverConversionEvent = (typeof ConversionEvent)[keyof typeof ConversionEvent];

export interface NaverAnalytics {
  cnv: (conversionId: NaverConversionEvent, paymentAmount?: string) => string;
  inflow: (host: string) => void;
}

export interface NaverAnlyticsAdditionalOption {
  wa: string;
}

export interface NaverAnalyticsConversionData {
  cnv: string;
}

export type NaverAnalyticsFunction = (data: Partial<NaverAnalyticsConversionData>) => void;
